// extracted by mini-css-extract-plugin
module.exports = {"container":"_2mrUnP","inner":"_3XJMZe","labels":"_2icOsS","note":"_3T--AF","image":"_2tfypN","shine-lines":"_37QPUL"};